import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const DisclaimerContext = createContext(null);

const STORAGE_KEY = "icc_disclaimer_accepted_v1";
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const DisclaimerProvider = ({ children }) => {
  const [accepted, setAccepted] = useState(false);
  const [hydrated, setHydrated] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === "true") setAccepted(true);
    setHydrated(true);
  }, []);

  const accept = async () => {
    try {
      await axios.post(`${API}/disclaimer/accept`, {
        user_agent: navigator.userAgent,
      });
    } catch (e) {
      // non-blocking — still allow access
      console.warn("Disclaimer logging failed", e);
    }
    localStorage.setItem(STORAGE_KEY, "true");
    setAccepted(true);
  };

  return (
    <DisclaimerContext.Provider value={{ accepted, accept, hydrated }}>
      {children}
    </DisclaimerContext.Provider>
  );
};

export const useDisclaimer = () => useContext(DisclaimerContext);
